if (!customElements.get('product-form')) {
  customElements.define(
    'product-form', 
    class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      if (this.form) {
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      }
      
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      //if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
    
      this.submitButton.classList.add('loading');
    
      this.querySelector('.loading-overlay').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
        console.log("this cart ==",this.cart);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        //this.cart.setActiveElement(document.activeElement);
        this.cart.classList.add('animate', 'active');
      }
      config.body = formData;
      
      // this.submitButton.classList.remove('loading');
      // if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
      // if (!this.error) this.submitButton.removeAttribute('aria-disabled');
      // this.querySelector('.loading-overlay').classList.add('hidden');

       fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          ray('After Shopify ajax callsss');
          ray(response);
          if (response.status) {
            this.handleErrorMessage(response.description);
          
            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }
           getProductTitle();
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            // console.log("dfgfdgfdgf", response);
            this.cart.renderContents(response);
          }
       
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay').classList.add('hidden');
           if (window.location.pathname.includes('/cart')) {
                setTimeout(() => {
                    window.location.href = window.location.pathname;
                }, 200);
            }
        }); 
      
      const cartRecomendation = new Event("start");
      document.dispatchEvent(cartRecomendation);
      // addFreeProducts();
   
       
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

function getProductTitle() {
    
    // Replace 'YOUR_VARIANT_ID' with the actual variant ID
    var variantId = '40235713101873';

    // Make a request to Shopify's Storefront API to fetch product details
    $.ajax({
      url: '/products.json?variant=' + variantId,
      dataType: 'json',
      success: function(response) {
        // Extract product title from the API response
        var product = response.products[0]; // Assuming only one product is returned
        var image = product.images[0].src;
        var title = product.title;
        var description = product.body_html;
       
        // Update the HTML element with the product title
        $('.free-product-title').text(title);
        $('.free-product-description').html(description);
        $(".free-product-image").attr("src", image);
      },
      error: function(xhr, status, error) {
        console.error(error);
      }
    });
}
var culturelleAddToCart = function () {

    fetch('/cart/add.js', {
     method: 'POST',
     headers: {
      'Content-Type': 'application/json'
     },
     body: JSON.stringify({
      items: [{
  	    id:  40235713101873 ,
  	    quantity: 1,
      }],
     })
    }).then(response => {
       console.log(response);
      console.log('Culturelle Free gift added');
    });
   }